export default import.meta.ROLLUP_FILE_URL_cn7IAAGY294pWGc7MpElVg